import { Button } from '@material-ui/core';
import React, { useEffect, useRef } from 'react';
import { getPluginImageSlotState, PLUGIN_IMAGE_SLOTS, readPngAsDataUri, withoutPluginImageChange, withPluginImagePick, withPluginImageRemoved } from './plugin-images.utils';
const previewStyle = {
    border: '1px solid #ccc',
    maxHeight: 200,
    maxWidth: 200
};
export const PluginImagesSection = ({ saved, pending, onChange, onError, readFile = readPngAsDataUri }) => {
    // Reads that finish after unmount (e.g. the parent remounts on reset) are dropped.
    const mountedRef = useRef(true);
    useEffect(() => () => {
        mountedRef.current = false;
    }, []);
    const handlePick = (key) => (e) => {
        const file = e.target.files?.[0];
        e.target.value = '';
        if (!file) {
            return;
        }
        readFile(file)
            .then((dataUri) => {
            if (mountedRef.current) {
                onChange((latest) => withPluginImagePick(latest, key, dataUri));
            }
        })
            .catch((error) => {
            console.error(error);
            onError(error.message);
        });
    };
    return (React.createElement(React.Fragment, null, PLUGIN_IMAGE_SLOTS.map(({ key, label }) => {
        const { status, previewSrc } = getPluginImageSlotState(key, saved, pending);
        return (React.createElement("div", { "data-testid": `plugin-image-${key}`, key: key },
            React.createElement("strong", { style: { display: 'block', margin: '12px 0 4px' } }, label),
            React.createElement("div", { style: { display: 'flex', gap: '1rem', alignItems: 'center' } },
                React.createElement(Button, { component: "label", variant: "outlined" },
                    "Choose image",
                    React.createElement("input", { accept: "image/png", "aria-label": `Choose ${label} image`, hidden: true, onChange: handlePick(key), type: "file" })),
                previewSrc ? (React.createElement("img", { alt: `${label} ${status === 'pending' ? 'new' : 'current'} image`, src: previewSrc, style: previewStyle })) : (React.createElement("span", { style: { color: '#666' } }, status === 'removed'
                    ? 'Will be removed on save'
                    : 'Using default Vouched image')),
                status === 'pending' || status === 'saved' ? (React.createElement(Button, { onClick: () => {
                        onChange((latest) => withPluginImageRemoved(latest, saved, key));
                    } }, status === 'pending' ? 'Discard new image' : 'Remove')) : null,
                status === 'removed' ? (React.createElement(Button, { onClick: () => {
                        onChange((latest) => withoutPluginImageChange(latest, key));
                    } }, "Undo remove")) : null)));
    })));
};
